
<div [class]="thumbImageContainerClass" [style]="thumbImageContainerStyle">
  <img  (click)="showFullScreenImage()" [src]="thumbImageUrl" alt="{{description}}" [style]="thumbImageStyle" />
</div>

<kendo-dialog class="k-dialog-full" *ngIf="isPhotoPopupOpen" [title]="description" (close)="closeFullScreenImage()">
  <div class="container-fluid">
    <div class="img-canvas" #imgcanvas></div>
  </div>
</kendo-dialog>